import {
  ClicksRecommendationsRequest,
  QueriesRecommendationsRequest,
  SectionRecommendationsRequest,
  UserRecommendationsRequest
} from '@empathy/search-adapter';
import { container } from '../../../container';
import { DEPENDENCIES } from '../../../container/dependencies.const';
import { DiscoveryWallState } from '../../../models';
import { UserService } from '../../../services';
import { isArrayEmptyOrNull } from '../../../utils';
import { RootStoreState } from '../../store.interfaces';
import { DISCOVERY_WALL_GETTERS_KEYS } from '../discovery-wall.const';
import { DiscoveryWallGetter } from '../discovery-wall.interfaces';

export class DiscoveryWallRequestsGetter implements DiscoveryWallGetter {
  getters = {
    [DISCOVERY_WALL_GETTERS_KEYS.clicksRecommendationsRequest]: (state: DiscoveryWallState, getters: any,
      rootState: RootStoreState): ClicksRecommendationsRequest | null => {
      const productIds = rootState.history.clickedResultHistory.history;
      const { section, consent } = rootState.config.dynamic;
      return !consent || isArrayEmptyOrNull(productIds)
        ? null
        : {
          origin: state.origin,
          productIds, // TODO Slice resultIds
          section,
          ...this.getUserInfo()
        };
    },
    [DISCOVERY_WALL_GETTERS_KEYS.sectionRecommendationsRequest]: (state: DiscoveryWallState, getters: any,
      rootState: RootStoreState): SectionRecommendationsRequest | null => {
      const { section, consent } = rootState.config.dynamic;
      return section
        ? {
          origin: state.origin,
          section,
          ...(consent && this.getUserInfo())
        }
        : null;
    },
    [DISCOVERY_WALL_GETTERS_KEYS.queriesRecommendationsRequest]: (state: DiscoveryWallState, getters: any,
      rootState: RootStoreState): QueriesRecommendationsRequest | null => {
      const queries = rootState.history.queryHistory.map(historyTerm => historyTerm.term);
      const { section, consent } = rootState.config.dynamic;
      return !consent || isArrayEmptyOrNull(queries)
        ? null
        : {
          origin: state.origin,
          queries, // TODO Slice queries
          section,
          ...this.getUserInfo()
        };
    },
    [DISCOVERY_WALL_GETTERS_KEYS.userRecommendationsRequest]: (state: DiscoveryWallState, getters: any,
      rootState: RootStoreState): UserRecommendationsRequest | null => {
      const { section, consent } = rootState.config.dynamic;
      return !consent
        ? null
        : {
          origin: state.origin,
          section,
          ...this.getUserInfo()
        };
    }
  };

  protected getUserInfo(): Omit<UserRecommendationsRequest, 'origin'> {
    const userService = container.get<UserService>(DEPENDENCIES.UserService);
    return userService.getUserInfo();
  }
}
